var map = {
	"./authorize-net-integration.png": "b51e",
	"./authorize.net-integration.png": "1058",
	"./braintree-integration.png": "8fee",
	"./groove_pay-integration.png": "d3a5",
	"./groovepay-integration.png": "dc81",
	"./groovepay_automated-integration.png": "f206",
	"./groovepaybr-integration.png": "92ea",
	"./mollie-integration.png": "bee8",
	"./nmi-integration.png": "70b5",
	"./paypal-integration.png": "ad9d",
	"./paypal_commerce-integration.png": "1e09",
	"./paystack-integration.png": "c67e",
	"./stax-integration.png": "2859",
	"./stripe-integration.png": "438c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3754";